<template>
  <div class="modal fade" ref="modal" tabindex="-1" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Alterar filas em lote</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar" :disabled="ocupado">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <ul class="nav nav-tabs mb-3">
            <li class="nav-item" v-for="item in abas" :key="item.valor">
              <a href="javascript:void(0)" class="nav-link" :class="{ active: aba == item.valor, disabled: ocupado }" @click="trocarAba(item.valor)">
                <i :class="item.icone"></i> {{ item.nome }}
              </a>
            </li>
          </ul>

          <!-- ABA AGENDAMENTOS: LISTA COM CANCELAMENTO -->
          <div v-if="aba == 'agendados'">
            <div class="d-flex align-items-center mb-2">
              <small class="text-muted">Agendamentos ativos e dos últimos 30 dias. Clique na linha para ver os usuários.</small>
              <button type="button" class="btn btn-outline-primary btn-sm ml-auto" @click="carregarAgendamentos" :disabled="carregandoAgendamentos">
                <i class="fas fa-sync-alt" :class="{ 'fa-spin': carregandoAgendamentos }"></i> Atualizar
              </button>
            </div>
            <div class="table-responsive" style="max-height: 420px; overflow-y: auto;">
              <table class="table table-sm mb-0">
                <thead>
                  <tr><th>Data/hora</th><th>Alteração</th><th>Usuários</th><th>Situação</th><th></th></tr>
                </thead>
                <tbody>
                  <template v-for="ag in agendamentos">
                    <tr :key="'ag' + ag.id" style="cursor: pointer;" @click="alternarAgendamento(ag.id)">
                      <td class="text-nowrap">
                        {{ formatarDataHora(ag.executarEm) }}
                        <small v-if="ag.terminaEm" class="d-block text-muted">até {{ formatarDataHora(ag.terminaEm) }}</small>
                        <small class="d-block text-muted">por {{ ag.responsavel }}</small>
                      </td>
                      <td>{{ ag.descricao }}</td>
                      <td class="text-nowrap">
                        <span v-for="st in statusComContagem(ag)" :key="st.valor" class="badge mr-1" :class="st.classe">{{ st.nome }}: {{ ag.contagem[st.valor] }}</span>
                      </td>
                      <td><span class="badge" :class="situacaoAgendamento(ag).classe">{{ situacaoAgendamento(ag).nome }}</span></td>
                      <td class="text-right">
                        <button v-if="ag.status == 'agendado'" type="button" class="btn btn-outline-danger btn-sm" :disabled="ocupado" @click.stop="cancelarAgendamento(ag)" title="Cancelar as alterações ainda não aplicadas">
                          <i class="fas fa-times"></i> Cancelar
                        </button>
                      </td>
                    </tr>
                    <tr v-if="agendamentoAberto == ag.id" :key="'us' + ag.id">
                      <td colspan="5" class="bg-light">
                        <span v-for="usr in ag.usuarios" :key="usr.id" class="badge mr-1 mb-1" :class="classeStatusUsuario(usr.status)" :title="usr.mensagem || ''">
                          {{ usr.login }} — {{ nomeStatusUsuario(usr.status) }}
                        </span>
                        <small v-if="ag.canceladoPor" class="d-block text-muted">Cancelado por {{ ag.canceladoPor }} em {{ formatarDataHora(ag.canceladoEm) }}</small>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="!carregandoAgendamentos && agendamentos.length == 0">
                    <td colspan="5" class="text-center text-muted">Nenhum agendamento encontrado.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- RESULTADO DO AGENDAMENTO -->
          <div v-else-if="estado == 'resultado' && aba == 'agendar'" class="text-center py-3">
            <i class="fas fa-check-circle text-success" style="font-size: 42px;"></i>
            <template v-if="quando == 'agora'">
              <p class="mt-3 mb-1" style="font-size: 16px;">
                <strong>{{ resultado.contagem.aplicado }}</strong> {{ resultado.contagem.aplicado == 1 ? 'usuário alterado' : 'usuários alterados' }},
                <strong>{{ resultado.contagem.sem_mudanca }}</strong> sem mudança.
              </p>
              <p v-if="resultado.contagem.aguardando > 0" class="mb-1 text-warning">
                <strong>{{ resultado.contagem.aguardando }}</strong> {{ resultado.contagem.aguardando == 1 ? 'operador logado receberá' : 'operadores logados receberão' }}
                a alteração ao deslogar e logar novamente.
              </p>
              <p v-if="resultado.contagem.erro > 0" class="mb-1 text-danger">
                <strong>{{ resultado.contagem.erro }}</strong> com erro (veja em Agendamentos).
              </p>
            </template>
            <p v-else class="mt-3 mb-1" style="font-size: 16px;">
              Alteração agendada para <strong>{{ formatarDataHora(resultado.executarEm) }}</strong>
              ({{ resultado.usuarios.length }} {{ resultado.usuarios.length == 1 ? 'usuário' : 'usuários' }}).
            </p>
            <p v-if="resultado.terminaEm" class="mb-1">
              Retorno às filas anteriores em <strong>{{ formatarDataHora(resultado.terminaEm) }}</strong>.
            </p>
            <a href="javascript:void(0)" @click="trocarAba('agendados')">Ver agendamentos</a>
          </div>

          <!-- RESULTADO (4.5) -->
          <div v-else-if="estado == 'resultado'" class="text-center py-3">
            <i class="fas fa-check-circle text-success" style="font-size: 42px;"></i>
            <p class="mt-3 mb-1" style="font-size: 16px;">
              <strong>{{ resultado.alterados }}</strong> {{ resultado.alterados == 1 ? 'usuário alterado' : 'usuários alterados' }},
              <strong>{{ resultado.semMudanca }}</strong> sem mudança.
            </p>
            <a v-if="resultado.alterados > 0" :href="`${urlHistorico}?lote=${resultado.loteId}`" target="_blank">Ver histórico do lote</a>
          </div>

          <!-- ABAS DE ALTERAÇÃO SEM USUÁRIO SELECIONADO (MODAL ABERTO PELO BOTÃO "AGENDAMENTOS") -->
          <p v-else-if="usuarios.length == 0" class="text-muted text-center py-3">
            Selecione os usuários na lista para alterar ou agendar a alteração das filas.
          </p>
          <template v-else>
            <p class="mb-2">
              <strong>{{ usuarios.length }}</strong> {{ usuarios.length == 1 ? 'usuário selecionado' : 'usuários selecionados' }}
            </p>

            <!-- ESCOLHA DA OPERAÇÃO E DAS FILAS (4.3) -->
            <fieldset :disabled="estado != 'formulario'">
              <div class="btn-group btn-group-toggle d-flex mb-3" role="group">
                <label v-for="op in operacoes" :key="op.valor" class="btn btn-outline-primary w-100" :class="{ active: operacao == op.valor }">
                  <input type="radio" :value="op.valor" v-model="operacao" autocomplete="off" /> {{ op.nome }}
                </label>
              </div>
              <p class="text-muted"><small>{{ descricaoOperacao }}</small></p>

              <div v-if="operacao == 'mover'" class="row">
                <div class="col-md-6">
                  <label>Fila de origem</label>
                  <select class="form-control" v-model="filaOrigem">
                    <option value="">Selecione</option>
                    <option v-for="fila in filas" :key="fila.id" :value="String(fila.id)">{{ nomeFila(fila.id) }} — {{ contagens[String(fila.id)] || 0 }} de {{ usuarios.length }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label>Fila de destino</label>
                  <select class="form-control" v-model="filaDestino">
                    <option value="">Selecione</option>
                    <option v-for="fila in filas" :key="fila.id" :value="String(fila.id)" :disabled="String(fila.id) == filaOrigem">{{ nomeFila(fila.id) }} — {{ contagens[String(fila.id)] || 0 }} de {{ usuarios.length }}</option>
                  </select>
                </div>
              </div>

              <filas-checkbox-component
                v-else
                id="filasLote"
                title="Filas"
                v-model="filasSelecionadas"
                :filas="filas"
                :contagens="contagens"
                :total="usuarios.length"
                altura="220px"
              ></filas-checkbox-component>

              <!-- QUANDO FAZER A ALTERAÇÃO (ABA AGENDAR) -->
              <div v-if="aba == 'agendar'" class="mt-3">
                <label class="d-block mb-1"><strong>Quando</strong></label>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="quandoAgora" class="custom-control-input" value="agora" v-model="quando" />
                  <label class="custom-control-label" for="quandoAgora">Agora</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="quandoAgendar" class="custom-control-input" value="agendar" v-model="quando" />
                  <label class="custom-control-label" for="quandoAgendar">Agendar data e hora</label>
                </div>

                <div v-if="quando == 'agendar'" class="row mt-2">
                  <div class="col-md-6">
                    <label for="dataAgendada">Data</label>
                    <input type="date" id="dataAgendada" class="form-control" v-model="dataAgendada" :min="hoje" />
                  </div>
                  <div class="col-md-6">
                    <label for="horaAgendada">Hora</label>
                    <input type="time" id="horaAgendada" class="form-control" v-model="horaAgendada" />
                  </div>
                  <div class="col-12">
                    <small class="text-danger" v-if="dataAgendada && horaAgendada && !dataFutura">A data e hora devem ser futuras.</small>
                  </div>
                </div>

                <!-- DATA DE TÉRMINO: NA DATA OS USUÁRIOS VOLTAM ÀS FILAS ANTERIORES -->
                <div class="custom-control custom-checkbox mt-3">
                  <input type="checkbox" id="comTermino" class="custom-control-input" v-model="comTermino" />
                  <label class="custom-control-label" for="comTermino">Definir data de término (os usuários voltam às filas anteriores)</label>
                </div>
                <div v-if="comTermino" class="row mt-2">
                  <div class="col-md-6">
                    <label for="dataTermino">Data de término</label>
                    <input type="date" id="dataTermino" class="form-control" v-model="dataTermino" :min="dataAgendada || hoje" />
                  </div>
                  <div class="col-md-6">
                    <label for="horaTermino">Hora de término</label>
                    <input type="time" id="horaTermino" class="form-control" v-model="horaTermino" />
                  </div>
                  <div class="col-12">
                    <small class="text-danger" v-if="dataTermino && horaTermino && !terminoValido">A data e hora de término devem ser posteriores à da alteração.</small>
                  </div>
                </div>

                <small class="text-muted d-block mt-2">
                  Quem estiver logado em filas no horário da alteração recebe as novas filas ao deslogar e logar novamente
                  (a Tela do Operador mostra um aviso). Os demais são alterados na hora.
                  <template v-if="comTermino">
                    O mesmo vale para o retorno na data de término. Se o operador ficar logado o período todo, a alteração é cancelada.
                  </template>
                </small>
              </div>
            </fieldset>

            <!-- ESTADO A: HÁ OPERADORES LOGADOS (4.4) -->
            <div v-if="estado == 'bloqueado'" class="mt-3">
              <div class="alert alert-warning mb-2">
                <i class="fas fa-exclamation-triangle"></i>
                {{ textoBloqueio }} Solicite que façam logout das filas e tente novamente.
              </div>
              <div class="table-responsive" style="max-height: 220px; overflow-y: auto;">
                <table class="table table-sm table-striped mb-2">
                  <thead>
                    <tr><th>Operador</th><th>Ramal</th><th>Logado em</th><th>Desde</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="op in logados" :key="op.id">
                      <td>{{ op.login }}</td>
                      <td>{{ op.ramal }}</td>
                      <td>{{ op.fila }}<span v-if="op.pausado" class="badge badge-secondary ml-1">pausa</span></td>
                      <td>{{ formatarDesde(op.desde) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <button type="button" class="btn btn-outline-secondary btn-sm" @click="copiarLista"><i class="fas fa-copy"></i> Copiar lista</button>
              <button type="button" class="btn btn-outline-primary btn-sm" @click="revisar" :disabled="ocupado"><i class="fas fa-sync-alt"></i> Verificar novamente</button>
            </div>

            <!-- ESTADO B: PRÉ-VISUALIZAÇÃO (4.4) -->
            <div v-if="estado == 'previa'" class="mt-3">
              <!-- ABA AGENDAR: LOGADOS NÃO BLOQUEIAM, FICAM AGUARDANDO -->
              <template v-if="aba == 'agendar'">
                <div v-if="quando == 'agendar'" class="alert alert-secondary mb-2">
                  <i class="fas fa-clock"></i>
                  A alteração será feita em <strong>{{ formatarDataHora(executarEm) }}</strong>. A prévia abaixo usa as filas atuais dos usuários.
                </div>
                <div v-else-if="logados.length > 0" class="alert alert-warning mb-2">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{ logados.length == 1 ? '1 operador está logado em filas e receberá' : `${logados.length} operadores estão logados em filas e receberão` }}
                  a alteração quando deslogar e logar novamente: {{ logados.map(op => op.login).join(', ') }}.
                </div>
                <div v-if="comTermino" class="alert alert-secondary mb-2">
                  <i class="fas fa-undo"></i>
                  Em <strong>{{ formatarDataHora(terminaEm) }}</strong> os usuários voltam às filas anteriores: as filas adicionadas
                  por esta alteração são retiradas e as removidas são devolvidas.
                </div>
              </template>
              <div class="alert alert-info mb-2">
                {{ textoPrevia }}
                <div v-if="previa.semFila > 0" class="text-danger mt-1">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{ previa.semFila }} {{ previa.semFila == 1 ? 'usuário ficará' : 'usuários ficarão' }} sem nenhuma fila.
                </div>
              </div>
              <div class="table-responsive" style="max-height: 220px; overflow-y: auto;" v-if="previa.mudancas.length > 0">
                <table class="table table-sm mb-0">
                  <thead><tr><th>Usuário</th><th>De-para</th></tr></thead>
                  <tbody>
                    <tr v-for="mud in previa.mudancas" :key="mud.id">
                      <td>{{ mud.login }}</td>
                      <td>
                        <span v-for="id in mud.removidas" :key="'r' + id" class="badge badge-danger mr-1">− {{ nomeFila(id) }}</span>
                        <span v-for="id in mud.adicionadas" :key="'a' + id" class="badge badge-success mr-1">+ {{ nomeFila(id) }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </div>

        <div class="modal-footer">
          <!-- key EM CADA BOTÃO: SEM ELE O VUE REAPROVEITA O ELEMENTO CLICADO COMO OUTRO BOTÃO (EX.: "REVISAR" VIRA
               "CANCELAR" COM data-dismiss) ANTES DO CLIQUE CHEGAR AO BOOTSTRAP, E O MODAL FECHA SOZINHO -->
          <template v-if="aba == 'agendados' || usuarios.length == 0 || estado == 'resultado'">
            <button key="fechar" type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </template>
          <template v-else-if="estado == 'formulario'">
            <button key="cancelarFormulario" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button key="revisar" type="button" class="btn btn-primary" :disabled="!formularioValido || ocupado" @click="revisar">
              <i v-if="ocupado" class="fas fa-spinner fa-spin"></i> Revisar alterações
            </button>
          </template>
          <template v-else>
            <button key="voltar" type="button" class="btn btn-link mr-auto" @click="voltar" :disabled="ocupado">Voltar</button>
            <button key="cancelarPrevia" type="button" class="btn btn-secondary" data-dismiss="modal" :disabled="ocupado">Cancelar</button>
            <!-- RN-04: SÓ HABILITA SEM NINGUÉM LOGADO -->
            <button v-if="aba == 'agendar'" key="agendar" type="button" class="btn btn-success" :disabled="estado != 'previa' || ocupado || (quando == 'agora' && previa.mudancas.length == 0)" @click="confirmar">
              <i v-if="ocupado" class="fas fa-spinner fa-spin"></i> {{ quando == 'agora' ? 'Aplicar agora' : 'Agendar alteração' }}
            </button>
            <button v-else key="confirmar" type="button" class="btn btn-success" :disabled="estado != 'previa' || ocupado || previa.mudancas.length == 0" @click="confirmar">
              <i v-if="ocupado" class="fas fa-spinner fa-spin"></i> Confirmar alteração
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import FilasCheckbox from '../filters/FilasCheckbox.vue';

export default {
  components: { 'filas-checkbox-component': FilasCheckbox },
  props: {
    usuarios: { type: Array, default: () => [] },
    filas: { type: Array, default: () => [] },
    urlHistorico: { type: String, default: '/user_queues/historico' },
  },
  data() {
    return {
      operacoes: [
        { valor: 'adicionar', nome: 'Adicionar' },
        { valor: 'remover', nome: 'Remover' },
        { valor: 'mover', nome: 'Mover' },
        { valor: 'substituir', nome: 'Substituir' },
      ],
      operacao: 'adicionar',
      filasSelecionadas: [],
      filaOrigem: '',
      filaDestino: '',
      estado: 'formulario', // formulario | bloqueado | previa | resultado
      ocupado: false,
      logados: [],
      resultado: {},
      // ABAS: imediata (ALTERAÇÃO EM LOTE) | agendar (AGORA OU DATA/HORA, LOGADOS FICAM AGUARDANDO) | agendados
      abas: [
        { valor: 'imediata', nome: 'Alterar agora', icone: 'fas fa-random' },
        { valor: 'agendar', nome: 'Agendar alteração', icone: 'fas fa-clock' },
        { valor: 'agendados', nome: 'Agendamentos', icone: 'fas fa-list' },
      ],
      aba: 'imediata',
      quando: 'agendar',
      dataAgendada: '',
      horaAgendada: '',
      comTermino: false,
      dataTermino: '',
      horaTermino: '',
      agendamentos: [],
      carregandoAgendamentos: false,
      agendamentoAberto: null,
      statusUsuario: [
        { valor: 'aguardando', nome: 'Aguardando', classe: 'badge-warning' },
        { valor: 'aplicado', nome: 'Aplicado', classe: 'badge-success' },
        { valor: 'sem_mudanca', nome: 'Sem mudança', classe: 'badge-light' },
        { valor: 'cancelado', nome: 'Cancelado', classe: 'badge-secondary' },
        { valor: 'erro', nome: 'Erro', classe: 'badge-danger' },
      ],
    };
  },
  computed: {
    // "AUSTER FINANCEIRO — 4 de 12"
    contagens() {
      const mapa = {};
      this.usuarios.forEach(u => {
        (u.queue || []).map(String).forEach(id => { mapa[id] = (mapa[id] || 0) + 1; });
      });
      return mapa;
    },
    descricaoOperacao() {
      return {
        adicionar: 'Inclui as filas marcadas e mantém as atuais.',
        remover: 'Remove as filas selecionadas, mantendo inalteradas as demais filas.',
        mover: 'Troca a fila de origem pela de destino (só para quem está na origem).',
        substituir: 'Define exatamente as filas marcadas; as demais são removidas.',
      }[this.operacao];
    },
    hoje() {
      return moment().format('YYYY-MM-DD');
    },
    executarEm() {
      return `${this.dataAgendada} ${this.horaAgendada}`;
    },
    dataFutura() {
      const data = moment(this.executarEm, 'YYYY-MM-DD HH:mm', true);
      return data.isValid() && data.isAfter(moment());
    },
    terminaEm() {
      return `${this.dataTermino} ${this.horaTermino}`;
    },
    // DEPOIS DA ALTERAÇÃO (DATA AGENDADA OU AGORA)
    terminoValido() {
      const termino = moment(this.terminaEm, 'YYYY-MM-DD HH:mm', true);
      if (!termino.isValid() || !termino.isAfter(moment())) return false;
      return this.quando == 'agendar' ? termino.isAfter(moment(this.executarEm, 'YYYY-MM-DD HH:mm', true)) : true;
    },
    formularioValido() {
      if (this.usuarios.length == 0) return false;
      if (this.aba == 'agendar' && this.quando == 'agendar' && !this.dataFutura) return false;
      if (this.aba == 'agendar' && this.comTermino && !this.terminoValido) return false;
      if (this.operacao == 'mover') return this.filaOrigem !== '' && this.filaDestino !== '' && this.filaOrigem != this.filaDestino;
      if (this.operacao == 'substituir') return true;
      return this.filasSelecionadas.length > 0;
    },
    filasPayload() {
      return this.operacao == 'mover' ? [this.filaDestino] : this.filasSelecionadas;
    },
    // MESMA REGRA DO SERVIDOR (FilasLoteHelper::aplicarOperacao), SÓ PARA A PRÉ-VISUALIZAÇÃO
    previa() {
      const mudancas = [];
      let semFila = 0;
      let semMudanca = 0;

      this.usuarios.forEach(u => {
        const antes = Array.from(new Set((u.queue || []).map(String)));
        const depois = this.aplicar(antes);
        if (depois.length == 0 && antes.length > 0) semFila++;

        const adicionadas = depois.filter(id => !antes.includes(id));
        const removidas = antes.filter(id => !depois.includes(id));
        if (adicionadas.length == 0 && removidas.length == 0) {
          semMudanca++;
          return;
        }
        mudancas.push({ id: u.id, login: u.login, adicionadas, removidas });
      });

      return { mudancas, semFila, semMudanca };
    },
    textoPrevia() {
      const n = this.previa.mudancas.length;
      const usuarios = n == 1 ? '1 usuário' : `${n} usuários`;
      const nomes = this.filasPayload.map(id => this.nomeFila(id)).join(', ');
      const sem = this.previa.semMudanca;

      if (n == 0) return 'Nenhum usuário selecionado será alterado por esta operação.';

      switch (this.operacao) {
        case 'adicionar':
          return `${usuarios} ${n == 1 ? 'será adicionado' : 'serão adicionados'} a ${nomes}` + (sem ? ` (${sem} já ${sem == 1 ? 'estava' : 'estavam'}).` : '.');
        case 'remover':
          return `${usuarios} ${n == 1 ? 'será removido' : 'serão removidos'} de ${nomes}` + (sem ? ` (${sem} não ${sem == 1 ? 'estava' : 'estavam'}).` : '.');
        case 'mover':
          return `${usuarios} ${n == 1 ? 'será movido' : 'serão movidos'} de ${this.nomeFila(this.filaOrigem)} para ${this.nomeFila(this.filaDestino)}` + (sem ? ` (${sem} sem mudança).` : '.');
        case 'substituir':
          return `${usuarios} ${n == 1 ? 'ficará' : 'ficarão'} somente em ${nomes || 'nenhuma fila'}` + (sem ? ` (${sem} já ${sem == 1 ? 'estava' : 'estavam'} assim).` : '.');
      }
      return '';
    },
    textoBloqueio() {
      const n = this.logados.length;
      return n == 1
        ? '1 operador está logado em filas e não pode ser alterado agora.'
        : `${n} operadores estão logados em filas e não podem ser alterados agora.`;
    },
  },
  watch: {
    quando() {
      this.voltar();
    },
    comTermino() {
      this.voltar();
    },
    operacao() {
      this.filasSelecionadas = [];
      this.filaOrigem = '';
      this.filaDestino = '';
    },
  },
  mounted() {
    $(this.$refs.modal).on('hidden.bs.modal', this.resetar);
  },
  beforeDestroy() {
    $(this.$refs.modal).off('hidden.bs.modal', this.resetar);
  },
  methods: {
    abrir(aba = 'imediata') {
      this.resetar();
      this.trocarAba(aba);
      $(this.$refs.modal).modal('show');
    },
    trocarAba(aba) {
      if (this.ocupado) return;
      this.aba = aba;
      if (this.estado == 'resultado') this.resetar(aba);
      this.voltar();
      if (aba == 'agendados') this.carregarAgendamentos();
    },
    resetar(aba = 'imediata') {
      this.aba = typeof aba === 'string' ? aba : 'imediata';
      this.quando = 'agendar';
      this.dataAgendada = '';
      this.horaAgendada = '';
      this.comTermino = false;
      this.dataTermino = '';
      this.horaTermino = '';
      this.agendamentoAberto = null;
      this.operacao = 'adicionar';
      this.filasSelecionadas = [];
      this.filaOrigem = '';
      this.filaDestino = '';
      this.estado = 'formulario';
      this.ocupado = false;
      this.logados = [];
      this.resultado = {};
    },
    voltar() {
      this.estado = 'formulario';
      this.logados = [];
    },
    aplicar(antes) {
      const filas = this.filasPayload.map(String);
      switch (this.operacao) {
        case 'adicionar':
          return Array.from(new Set(antes.concat(filas)));
        case 'remover':
          return antes.filter(id => !filas.includes(id));
        case 'mover':
          if (!antes.includes(this.filaOrigem)) return antes;
          return Array.from(new Set(antes.filter(id => id !== this.filaOrigem).concat(filas)));
        case 'substituir':
          return filas.slice();
      }
      return antes;
    },
    nomeFila(id) {
      const fila = this.filas.find(f => String(f.id) === String(id));
      if (!fila) return `Fila #${id}`;
      return fila.alias ? fila.alias : fila.name;
    },
    formatarDesde(desde) {
      if (!desde) return '-';
      const data = moment(desde);
      return data.isSame(moment(), 'day') ? data.format('HH:mm') : data.format('DD/MM HH:mm');
    },
    // "REVISAR ALTERAÇÕES" E "VERIFICAR NOVAMENTE" - CHECAGEM INFORMATIVA (RN-05)
    revisar() {
      // AGENDAMENTO FUTURO: QUEM ESTÁ LOGADO AGORA NÃO IMPORTA
      if (this.aba == 'agendar' && this.quando == 'agendar') {
        this.logados = [];
        this.estado = 'previa';
        return;
      }

      this.ocupado = true;
      axios.post('/user_queues/logados', { usuarios: this.usuarios.map(u => u.id) })
        .then(response => {
          const operadores = response.data.operadores || [];
          this.$emit('logados', operadores, true);
          this.mostrarBloqueio(operadores);
        })
        .catch(error => {
          this.erro(error, 'Não foi possível verificar quem está logado.');
        })
        .finally(() => { this.ocupado = false; });
    },
    mostrarBloqueio(operadores) {
      this.logados = operadores;
      // NA ABA AGENDAR OS LOGADOS SÓ FICAM AGUARDANDO (AVISO NA PRÉVIA)
      if (this.aba == 'agendar') {
        this.estado = 'previa';
        return;
      }
      this.estado = operadores.length > 0 ? 'bloqueado' : 'previa';
    },
    async confirmar() {
      // RN-12: CONFIRMAÇÃO EXTRA NO SUBSTITUIR OU QUANDO ALGUÉM FICA SEM FILA
      const precisaConfirmar = this.operacao == 'substituir' || this.previa.semFila > 0;
      if (precisaConfirmar) {
        const partes = [];
        if (this.operacao == 'substituir') partes.push('As filas atuais dos usuários selecionados serão substituídas.');
        if (this.previa.semFila > 0) partes.push(`${this.previa.semFila} ${this.previa.semFila == 1 ? 'usuário ficará' : 'usuários ficarão'} sem nenhuma fila.`);

        const resposta = await Swal.fire({
          title: 'Confirmar alteração',
          text: partes.join(' ') + ' Deseja continuar?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, alterar',
          cancelButtonText: 'Cancelar',
        });
        if (!resposta.value) return;
      }

      if (this.aba == 'agendar') {
        this.agendar(precisaConfirmar);
        return;
      }

      this.ocupado = true;
      axios.post('/user_queues/lote', {
        usuarios: this.usuarios.map(u => u.id),
        operacao: this.operacao,
        filas: this.filasPayload.map(Number),
        filaOrigem: this.operacao == 'mover' ? Number(this.filaOrigem) : null,
        confirmarSemFila: precisaConfirmar,
      })
        .then(response => {
          this.resultado = response.data;
          this.estado = 'resultado';
          this.$emit('concluido', response.data);
        })
        .catch(error => {
          // 409: ALGUÉM LOGOU ENTRE A REVISÃO E A CONFIRMAÇÃO - VOLTA PARA O ESTADO A
          if (error.response && error.response.status == 409) {
            const operadores = error.response.data.operadores || [];
            this.$emit('logados', operadores, true);
            this.mostrarBloqueio(operadores);
            return;
          }
          this.erro(error, 'Erro ao alterar as filas. Nenhuma alteração foi feita.');
        })
        .finally(() => { this.ocupado = false; });
    },
    agendar(confirmarSemFila) {
      this.ocupado = true;
      axios.post('/user_queues/agendar', {
        usuarios: this.usuarios.map(u => u.id),
        operacao: this.operacao,
        filas: this.filasPayload.map(Number),
        filaOrigem: this.operacao == 'mover' ? Number(this.filaOrigem) : null,
        confirmarSemFila: confirmarSemFila,
        quando: this.quando,
        executarEm: this.quando == 'agendar' ? this.executarEm : null,
        terminaEm: this.comTermino ? this.terminaEm : null,
      })
        .then(response => {
          this.resultado = response.data;
          this.estado = 'resultado';
          this.$emit('concluido', response.data);
        })
        .catch(error => {
          this.erro(error, 'Erro ao agendar a alteração das filas.');
        })
        .finally(() => { this.ocupado = false; });
    },
    carregarAgendamentos() {
      this.carregandoAgendamentos = true;
      axios.get('/user_queues/agendamentos')
        .then(response => { this.agendamentos = Array.isArray(response.data) ? response.data : []; })
        .catch(error => { this.erro(error, 'Não foi possível carregar os agendamentos.'); })
        .finally(() => { this.carregandoAgendamentos = false; });
    },
    alternarAgendamento(id) {
      this.agendamentoAberto = this.agendamentoAberto == id ? null : id;
    },
    async cancelarAgendamento(ag) {
      let detalhe = 'As alterações ainda não aplicadas serão canceladas; as já aplicadas não são desfeitas.';
      if (ag.retorno) detalhe = 'Quem ainda não retornou continuará nas filas atuais.';
      else if (ag.terminaEm) detalhe += ' Quem já foi alterado continua com o retorno às filas anteriores agendado.';

      const resposta = await Swal.fire({
        title: 'Cancelar agendamento',
        text: `${ag.descricao} (${this.formatarDataHora(ag.executarEm)}). ${detalhe} Deseja continuar?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, cancelar',
        cancelButtonText: 'Voltar',
      });
      if (!resposta.value) return;

      this.ocupado = true;
      axios.post(`/user_queues/agendamentos/${ag.id}/cancelar`)
        .then(() => { this.carregarAgendamentos(); })
        .catch(error => {
          this.erro(error, 'Erro ao cancelar o agendamento.');
          this.carregarAgendamentos();
        })
        .finally(() => { this.ocupado = false; });
    },
    situacaoAgendamento(ag) {
      if (ag.status == 'cancelado') return { nome: 'Cancelado', classe: 'badge-secondary' };
      if (ag.status == 'concluido') return { nome: 'Concluído', classe: 'badge-success' };
      if (moment(ag.executarEm).isAfter(moment())) return { nome: 'Agendado', classe: 'badge-info' };
      return { nome: 'Aguardando logout', classe: 'badge-warning' };
    },
    statusComContagem(ag) {
      return this.statusUsuario.filter(st => ag.contagem[st.valor] > 0);
    },
    nomeStatusUsuario(status) {
      const st = this.statusUsuario.find(el => el.valor == status);
      return st ? st.nome : status;
    },
    classeStatusUsuario(status) {
      const st = this.statusUsuario.find(el => el.valor == status);
      return st ? st.classe : 'badge-light';
    },
    formatarDataHora(data) {
      if (!data) return '-';
      return moment(data).format('DD/MM/YYYY [às] HH:mm');
    },
    copiarLista() {
      const texto = this.logados.map(op => `${op.nome || op.login} (${op.login}) - ramal ${op.ramal}`).join('\n');
      const copiado = () => Swal.fire({ title: 'Lista copiada', type: 'success', timer: 1500, showConfirmButton: false });

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(texto).then(copiado).catch(() => this.copiarFallback(texto, copiado));
      } else {
        this.copiarFallback(texto, copiado);
      }
    },
    copiarFallback(texto, callback) {
      const area = document.createElement('textarea');
      area.value = texto;
      area.style.position = 'fixed';
      area.style.opacity = '0';
      // DENTRO DO MODAL, SENÃO O FOCUS TRAP DO BOOTSTRAP IMPEDE A SELEÇÃO
      this.$refs.modal.appendChild(area);
      area.select();
      try { document.execCommand('copy'); callback(); } catch (e) { console.error(e); }
      this.$refs.modal.removeChild(area);
    },
    erro(error, padrao) {
      console.error(error);
      const mensagem = error.response && error.response.data && error.response.data.mensagem ? error.response.data.mensagem : padrao;
      Swal.fire({ title: 'Alterar filas em lote', type: 'error', text: mensagem });
    },
  },
};
</script>
